import { useLazyQuery, useQuery } from "@apollo/client";
import { CATEGORIES } from "../category.queries";
import { CategoriesQuery } from "../../../__generated__/CategoriesQuery";

export const useCategories = () => {
  return useQuery<CategoriesQuery>(CATEGORIES);
};

export const useLazyCategories = () => {
  return useLazyQuery<CategoriesQuery>(CATEGORIES);
};
